import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { TAG_TYPES } from '../config/tagTypes';
import { getToken } from '../lib/token';
import { sessionLoggedOut } from '../../entities/session/model/actions';

const rawBaseQuery = fetchBaseQuery({
  baseUrl: '/',
  prepareHeaders: (headers) => {
    const token = getToken();
    if (token) {
      headers.set('Authorization', token);
    }
    return headers;
  },
});

const AUTH_EXPIRED_MARKERS = ['авторизация устарела', 'токен'];

function getErrorText(data: unknown): string {
  if (typeof data === 'string') {
    try {
      return String(JSON.parse(data)?.error ?? data);
    } catch {
      return data;
    }
  }
  return String((data as { error?: unknown })?.error ?? '');
}

function isAuthExpired(error: FetchBaseQueryError): boolean {
  const status = error.status === 'PARSING_ERROR' ? error.originalStatus : error.status;

  if (status !== 401 && status !== 400) {
    return false;
  }

  const errorText = getErrorText(error.data).toLowerCase();
  return AUTH_EXPIRED_MARKERS.some((marker) => errorText.includes(marker));
}

export const baseQueryWithAuth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);

  if (result.error && isAuthExpired(result.error)) {
    api.dispatch(sessionLoggedOut());
  }

  return result;
};

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithAuth,
  tagTypes: TAG_TYPES,
  endpoints: () => ({}),
});